<template>
  <div class="products">
    <div class="toolbar" v-if="!isLoading">
      <h1>Có {{ totalProducts }} sản phẩm</h1>
      <div class="actions" ref="layouts">
        <div class="dropdown">
          <span
            class="dropdown-toggle"
            role="button"
            id="dropdownMenuLink"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Sắp xếp
          </span>
          <ul
            ref="dropdown"
            class="dropdown-menu p-0"
            aria-labelledby="dropdownMenuLink"
          >
            <li class="subLVLi" v-for="(item, index) in dropdowns" :key="index">
              <span
                class="dropdown-item"
                @click.stop="showSubmenu($event.target)"
              >{{ item.label }}
              </span>
              <ul
                v-if="item.options"
                class="dropdown-menu dropdown-submenu p-0"
              >
                <li
                  v-for="option in item.options"
                  :key="option.key"
                  :data-group="item.name"
                  :data-id="option.key"
                  @click.stop="applyFilter($event.target)"
                >
                  <span class="dropdown-item">{{ option.value }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="layouts d-flex">
          <img
            @click="changeLayout('row-cols-2', 0)"
            src="@/assets/icons/row-vertical.svg"
            alt=""
          />
          <img
            @click="changeLayout('row-cols-3', 1)"
            src="@/assets/icons/element-4.png"
            alt=""
          />
          <img
            @click="changeLayout('row-cols-4', 2)"
            src="@/assets/icons/element-3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <Loading v-if="isLoading" />
    <ProductContainer
      v-else
      :products="products"
      :configs="configs"
      @loadMore="loadMore()"
    />
  </div>
</template>

<script>
import ProductContainer from "./components/ProductContainer.vue";
import Loading from "./components/Loading.vue";
import Select from "./components/Dropdown.vue";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");
export default {
  name: "Products",
  components: {
    ProductContainer,
    Loading,
    Select,
  },
  data() {
    return {
      configs: {
        layout: "row-cols-4",
        class: "row g-3",
      },
      dropdowns: [
        {
          label: "Giá",
          name: "price",
          options: [
            { key: 1, value: "Tăng dần" },
            { key: 2, value: "Giảm dần" },
          ],
        },
        {
          label: "Ngày cập nhật",
          name: "date",
          options: [
            { key: 1, value: "Mới nhất" },
            { key: 2, value: "Cũ nhất" },
          ],
        },
      ],
      filterOptions: { date: null, price: null },
    };
  },
  created() {
    const params = { page: 1 };
    this.getProducts(params);
  },
  methods: {
    ...mapActions(["getProducts", "sortProducts", "mergeProducts"]),
    loadMore() {
      this.mergeProducts();
      console.log("Load more");
    },
    changeLayout(layout, index) {
      this.configs.layout = layout;
      this.$refs.layouts.querySelectorAll("img").forEach((img, i) => {
        img.classList.remove("active");
        if (index == i) img.classList.add("active");
      });
    },
    showSubmenu(el) {
      const dropdown = this.$refs.dropdown.querySelectorAll("ul");
      dropdown.forEach((el) => el.classList.remove("show"));

      const submenu = el.nextElementSibling;
      submenu.classList.toggle("show");
    },
    applyFilter(el) {
      const parent = el.parentNode;
      const grandParent = parent.parentNode;

      const group = parent.dataset.group;
      const id = parent.dataset.id;

      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        this.filterOptions[group] = null;
        grandParent.classList.remove("show");
        this.$refs.dropdown.previousElementSibling.click();
        return;
      }

      grandParent
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("active"));
      parent.classList.add("active");

      this.filterOptions[group] = +id;
      grandParent.classList.remove("show");
      this.$refs.dropdown.previousElementSibling.click();
      // alert(this.filterOptions);
      this.sortProducts(this.filterOptions);
    },
  },
  computed: {
    totalProducts() {
      return this.products.length;
    },
    ...mapState(["products", "isLoading"]),
  },
};
</script>
<style scoped lang="scss">
.products {
  padding-top: 50px;
  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 50px;
    h1 {
      font-size: 24px;
    }
    .actions {
      display: flex;
      align-items: center;

      .dd-filter {
        height: 20px;
        font-size: 14px;
        box-sizing: border-box;
        cursor: pointer;
        margin-right: 20px;
        z-index: 50;
        &.active .dd-menu {
          display: block !important;
        }
      }

      span {
        display: inline-block;
        margin-right: 15px;
        font-size: 14px;
        font-weight: 500;
        opacity: 0.6;
      }
      img {
        cursor: pointer;
        height: 25px;
        margin-right: 10px;
        opacity: 0.6;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          opacity: 1;
        }
      }
    }
  }
}
.dropdown-menu {
  width: 130px !important;
  min-width: unset !important;
  span.dropdown-item {
    margin-right: 0 !important;
    &:active {
      background-color: #3b664a;
      color: #fff;
    }
  }
  .dropdown-submenu {
    li.active {
      background-color: #3b664a;
      span {
        color: #fff !important;
        &:hover {
          background-color: unset;
        }
      }
    }
  }
}
.subLVLi {
  position: relative;
  span {
    cursor: pointer;
    color: #000;
    opacity: 1 !important;
  }
  ul {
    right: -130px;
    top: 50%;
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .toolbar {
    padding: 0 80px;
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .toolbar {
    padding: 0 60px;
    .subLVLi {
      ul {
        right: 128px;
        top: 50%;
      }
    }
    .layouts {
      display: none !important;
    }
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .toolbar {
    padding: 0 40px;
    .subLVLi {
      ul {
        right: 128px;
        top: 50%;
      }
    }
    .layouts {
      display: none !important;
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  .toolbar {
    flex-direction: row;
    .subLVLi {
      ul {
        right: 128px;
        top: 50%;
      }
    }
    .layouts {
      display: none !important;
    }
  }
}
</style>
